import 'react-dd-menu/dist/react-dd-menu.min.css';
import DropdownMenu from 'react-dd-menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import Style from '../../../../styles/common';

const CaretIcon = styled(FontAwesomeIcon)`
  margin-left: 10px;
`;

const ToggleLink = styled('div')`
  color: ${Style.color.defaultText};
  cursor: pointer;
  padding: 10px;
`;

const SignOutLink = styled('span')`
  color: ${Style.color.ERROR} !important;
  cursor: pointer;
`;

class ContentHeaderDropdown extends React.Component {
  static propTypes = {
    onSignOut: PropTypes.func.isRequired,
  };

  state = {
    isMenuOpen: false
  };

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close = () => {
    this.setState({ isMenuOpen: false });
  };

  render() {
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: this.toggleLink,
      align: 'left'
    };

    return (
      <DropdownMenu {...menuOptions}>
        <li><Link to='/manage-events'>Manage events</Link></li>
        <li><SignOutLink onClick={this.props.onSignOut}>Sign out</SignOutLink></li>
      </DropdownMenu>
    );
  }

  get toggleLink() {
    return (
      <ToggleLink onClick={this.toggle}>
        Settings<CaretIcon icon="caret-down" />
      </ToggleLink>
    );
  }
}

export default ContentHeaderDropdown;



// WEBPACK FOOTER //
// ./src/views/Masthead/AuthLinks/AuthLinksDropdown/AuthLinksDropdown.js